import type { Hotel, OfferAndPackage } from '~/domains/graphql';

export function useHotelOffers(
  hotel: Ref<Hotel | null | undefined>,
): ComputedRef<OfferAndPackage[]> {
  const localPath = useLocalePath();
  const runtimeConfig = useRuntimeConfig();

  return computed<OfferAndPackage[]>(() => {
    if (!Array.isArray(hotel.value?.hotelOffers)) return [];

    return hotel.value?.hotelOffers.map(offer => {
      if (!offer) {
        return null;
      }

      const uri = localPath({
        name: 'hotel-hotelSlug-offer-offerSlug',
        params: {
          hotelSlug: hotel.value?.slug ?? '',
          offerSlug: offer.slug ?? '',
        },
      }).toString();

      return {
        description: offer.introduction,
        detailLink: `${runtimeConfig.public.baseUrl}${uri}`,
        id: offer.slug,
        picture: offer.heroImage,
        sectionTitle: offer.title,
        title: offer.subtitle,
      };
    }) as OfferAndPackage[];
  });
}
